<template>
  <div class="ae-basic-from">
    <div style="width: fit-content">
      <el-form ref="basicForm" style="display: flex;" label-position="left" label-width="90px">
        <div>
          <div class="form-card-wrapper" style="flex-direction: column">
            <div style="display: flex;flex-direction: row">
              <el-card class="form-card">
                <fieldset>
                  <el-form-item :label="$t('SeaExport.JobNo')">
                    <el-input v-model="job.jobNo" no="1" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.OperateType')">
                    <cargo-advance-select
                      no="2"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.local_cache_AirExportConstants$BUSINESS_MODELS"
                      callback-method-type="value"
                      :default-value="job.operateType"
                      :callback-params="{key:'operateType'}"
                      @parentCallBack="setJobSelectValue"
                    />

                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ConsignationCompany')">
                    <div style="display: flex;align-items: center">
                      <!--<i class="el-icon-success" @click="showSopDialog=true" />{{ job.customerId }} typeof {{ typeof job.customerId }}-->
                      <el-tooltip v-show="creditTip.showWarningImageB" :content="creditTip.warningImageBTip" placement="right-end">
                        <i
                          class="el-icon-warning"
                          style="color:red"
                        />
                      </el-tooltip>
                      <cargo-advance-select
                        no="3"
                        :disabled="viewStatus"
                        filterable
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{customer:true}"
                        callback-method-type="value"
                        :default-value="job.customerId||''"
                        :callback-params="{key:'customerId'}"
                        @parentCallBack="setJobSelectValue"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CustomerProperty')">
                    <el-tooltip :content="customerTip" placement="bottom">
                      <span
                        v-show="customerLevel.customerName"
                        style="color:#FD9A14"
                      >LV{{ customerLevel.level }}</span>
                      <span
                        v-show="customerLevel.customerName"
                        style="color:#D3A73B"
                      >&nbsp;{{ customerLevel.customerName }}</span>
                      <span v-show="contractStatusLabel" style="color:red">&nbsp;({{ contractStatusLabel }})</span>
                      <span v-show="advancePaymentLabel" style="color:brown">&nbsp;({{ advancePaymentLabel }})</span>
                    </el-tooltip>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.LoadingPort')">
                    <div style="display: flex;justify-content: space-between">
                      <el-input v-model="job.loadingPortCode" no="4" :disabled="viewStatus" style="width:60px;margin-right: 5px;" />
                      <cargo-advance-select
                        no="5"
                        filterable
                        :disabled="viewStatus"
                        :select-type="selectTypeNames.basic_data_Airport"
                        callback-method-type="value"
                        :default-value="job.loadingPortCode"
                        :callback-params="{key:'loadingPortCode'}"
                        style="flex: 1"
                        @parentCallBack="setJobSelectValue"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.PortOfDestination')">
                    <div style="display: flex;justify-content: space-between">
                      <el-input v-model="job.destinationPortCode" no="6" :disabled="viewStatus" style="width:60px;margin-right: 5px;" />
                      <cargo-advance-select
                        no="7"
                        filterable
                        :disabled="viewStatus"
                        :select-type="selectTypeNames.basic_data_Airport"
                        callback-method-type="value"
                        :default-value="job.destinationPortCode"
                        :callback-params="{key:'destinationPortCode'}"
                        style="flex: 1"
                        @parentCallBack="setJobSelectValue"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Airline')">
                    <el-input v-model="job.vesselLine" no="8" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item label="">
                    <div style="display: flex;justify-content: space-between">
                      <el-checkbox v-model="job.transfering" no="9" :disabled="viewStatus">{{ $t('SeaExport.Transit') }}</el-checkbox>
                      <el-button no="10" :disabled="viewStatus" type="primary">{{ $t('SeaExport.EnterTransitInfo') }}</el-button>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('Payment.solicitationType')">
                    <div style="display: flex;justify-content: space-between">
                      <cargo-advance-select
                        no="11"
                        filterable
                        :disabled="viewStatus"
                        :select-type="selectTypeNames.local_cache_CargoSource"
                        callback-method-type="value"
                        :default-value="job.cargoSource"
                        :callback-params="{key:'cargoSource'}"
                        style="width: 98px"
                        @parentCallBack="setJobSelectValue"
                      />
                      <cargo-advance-select
                        no="12"
                        filterable
                        :disabled="viewStatus"
                        :select-type="selectTypeNames.basic_data_CutomJobType"
                        :method-params="{type:job.lob, active: true}"
                        callback-method-type="value"
                        :default-value="job.customJobType"
                        :callback-params="{key:'customJobType'}"
                        style="width: 98px"
                        @parentCallBack="setJobSelectValue"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
                    <cargo-advance-select
                      no="13"
                      :disabled="viewStatus"
                      filterable
                      :select-type="selectTypeNames.basic_data_Company"
                      :method-params="{localAgent:true}"
                      callback-method-type="value"
                      :default-value="job.localAgent||''"
                      :callback-params="{key:'localAgent'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.DestinationAgent')">
                    <div style="display: flex;align-items: center">
                      <el-tooltip v-show="creditTip.showWarningImageC" :content="creditTip.warningImageCTip" placement="right-end">
                        <i
                          class="el-icon-warning"
                          style="color:red"
                        />
                      </el-tooltip>
                      <cargo-advance-select
                        no="14"
                        :disabled="viewStatus"
                        filterable
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{overseaAgent:true}"
                        callback-method-type="value"
                        :default-value="job.destinationAgent||''"
                        tag-name="englishName"
                        :callback-params="{key:'destinationAgent'}"
                        @parentCallBack="setJobSelectValue"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item v-if="job.cargoSource === 'NC'" :label="$t('SeaExport.NominatedAgent')">
                    <div style="display: flex;align-items: center">
                      <el-tooltip v-show="creditTip.showWarningImageA" :content="creditTip.warningImageATip" placement="right-end">
                        <i
                          class="el-icon-warning"
                          style="color:red"
                        />
                      </el-tooltip>
                      <cargo-advance-select
                        no="15"
                        :disabled="viewStatus"
                        filterable
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{overseaAgent:true}"
                        callback-method-type="value"
                        :default-value="job.designationAgent||''"
                        tag-name="englishName"
                        :callback-params="{key:'designationAgent'}"
                        @parentCallBack="setJobSelectValue"
                      />
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BookingAgent')">
                    <cargo-advance-select
                      no="16"
                      :disabled="viewStatus"
                      filterable
                      :select-type="selectTypeNames.basic_data_Company"
                      :method-params="{bookingAgent:true}"
                      callback-method-type="value"
                      :default-value="job.bookingAgent||''"
                      :callback-params="{key:'bookingAgent'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.DocCutOffDate')">
                    <el-date-picker
                      v-model="job.fileCutoff"
                      no="17"
                      :disabled="viewStatus"
                      type="date"
                      clearable
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm"
                    />
                  </el-form-item>

                  <el-form-item :label="$t('SeaExport.MasterBillNo')">
                    <div style="display: flex;align-items: center">
                      <el-checkbox v-model="job.express" no="18" style="margin-right: 5px">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
                      <!-- todo 控件只做到数据查看-->
                      <el-input v-if="!job.express" no="19" :value="job.mbl.substring(0,3)" :disabled="viewStatus" style="width: 80px;" />
                      <span v-if="!job.express" style="padding-right: 1.5px;padding-left: 1.5px;">-</span>
                      <el-input v-if="!job.express" no="20" :value="job.mbl.substring(3)" :disabled="viewStatus" style="width: 150px;" />
                      <el-input v-if="job.express" no="21" :value="job.mbl" :disabled="viewStatus" />
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-checkbox v-model="job.predictionOperation" no="22">{{ $t('SeaExport.PreAlertOperation') }}</el-checkbox>
                  </el-form-item>
                </fieldset>
              </el-card>
              <el-card class="form-card">
                <fieldset>
                  <el-form-item :label="$t('SeaExport.ContactPerson')">
                    <!-- todo 需根据逻辑单独请求获取-->
                    <div style="display: flex;justify-content: space-between">
                      <el-select v-model="job.customerContact" no="23" :disabled="viewStatus" style="flex: 1;margin-right:5px">
                        <el-option :label="$t('queryJob.DropDown')" :value="0" />
                      </el-select>
                      <el-link no="24" @click="showContactsInfoDialog=true">{{ $t('SeaExport.Detail') }}</el-link>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Tel')">
                    <el-input v-model="job.contactTelephone" no="25" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Fax')">
                    <el-input v-model="job.contactFax" no="26" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.LocalService')">
                    <!-- todo 赋值字段-->
                    <cargo-advance-select
                      no="27"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.local_cache_AirExportConstants$SUFFY_TYPES"
                      callback-method-type="value"
                      :default-value="job.loadingTerm"
                      :tag-name="isZh ? 'chineseName' : 'englishName'"
                      :callback-params="{key:'loadingTerm'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BookingProperty')">
                    <cargo-advance-select
                      no="28"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.local_cache_BookingTerm"
                      callback-method-type="value"
                      :default-value="job.bookingTerm"
                      :callback-params="{key:'bookingTerm'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CustomsDeclarationWay')">
                    <cargo-advance-select
                      no="29"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.local_cache_AirExportConstants$CUSTOM_CLAIMS"
                      callback-method-type="value"
                      :default-value="String(job.customClaim)||''"
                      tag-name="chineseName"
                      :callback-params="{key:'customClaim'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item v-if="job.customClaim===1" :label="$t('SeaExport.CustomsDeclarationType')">
                    <cargo-advance-select
                      no="30"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.local_cache_AirExportConstants$CUSTOM_CLAIMS2"
                      callback-method-type="value"
                      :default-value="job.customClaim2"
                      tag-name="chineseName"
                      :callback-params="{key:'customClaim2'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.TradeMethod')">
                    <cargo-advance-select
                      no="31"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_TradeTerm"
                      callback-method-type="value"
                      :default-value="job.tradeTerm"
                      :callback-params="{key:'tradeTerm'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.StatusOfCustomsDeclaration')">
                    <cargo-advance-select
                      no="32"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.local_cache_SystemConstants$DECLARE_CUSTOMS_STATE"
                      callback-method-type="value"
                      :default-value="String(job.declareCustomsState)||''"
                      :tag-name="isZh?'chineseName':'englishName'"
                      :callback-params="{key:'declareCustomsState'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.TradeTerms')">
                    <cargo-advance-select
                      no="33"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_IncoTerm"
                      callback-method-type="value"
                      :default-value="job.incoTerm"
                      :callback-params="{key:'incoTerm'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.AirlineCompany')">
                    <cargo-advance-select
                      no="34"
                      :disabled="viewStatus"
                      filterable
                      :select-type="selectTypeNames.basic_data_Company"
                      :method-params="{airCmp:true}"
                      callback-method-type="value"
                      :default-value="job.carrierId||''"
                      :callback-params="{key:'carrierId'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Flight')">
                    <el-input v-model="job.voyageFlight" no="35" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.OperationDate')">
                    <el-date-picker
                      v-model="job.customsDate"
                      no="36"
                      :disabled="viewStatus"
                      type="date"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.DateOfDeparture')">
                    <el-date-picker
                      v-model="job.etd"
                      no="37"
                      :disabled="viewStatus"
                      type="date"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.DateOfArrival')">
                    <el-date-picker
                      v-model="job.eta"
                      no="38"
                      :disabled="viewStatus"
                      type="date"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button no="39" :disabled="viewStatus" type="primary" style="margin-left: 0;">{{ $t('SeaExport.Select') }}</el-button>
                    <el-button no="40" :disabled="viewStatus" type="primary">{{ $t('SeaExport.New') }}</el-button>
                    <el-button no="41" :disabled="viewStatus" type="primary">{{ $t('SeaExport.Add3') }}</el-button>
                    <el-button no="42" :disabled="viewStatus" type="primary">{{ $t('SeaExport.Separate') }}</el-button>
                  </el-form-item>
                </fieldset>
              </el-card>
              <el-card class="form-card">
                <fieldset>
                  <el-form-item label="">
                    <div style="display: flex">
                      <el-checkbox v-model="job.virtualHBL" no="43" :disabled="viewStatus">{{ $t('SeaExport.FormalHbl') }}</el-checkbox>
                      <el-checkbox v-model="job.itmService" no="44" :disabled="viewStatus">{{ $t('SeaExport.ForeignTrade') }}</el-checkbox>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('Payment.warehouseNo')">
                    <el-input v-model="job.warehouseNo" no="45" :disabled="viewStatus" type="textarea" :rows="5" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')">
                    <el-input v-model="job.customerRefNo" no="46" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.FirstLegNo')">
                    <el-input v-model="job.relatedJob2" no="47" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item label="KC No">
                    <el-input v-model="job.kcNo" no="48" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ItemNo')">
                    <el-input v-model="job.poNo" no="49" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
                    <cargo-advance-select
                      no="50"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_PaymentTerm"
                      callback-method-type="value"
                      :default-value="job.paymentTermMBL"
                      :callback-params="{key:'paymentTermMBL'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.HBLFreightClause')">
                    <cargo-advance-select
                      no="51"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_PaymentTerm"
                      callback-method-type="value"
                      :default-value="job.paymentTermHBL"
                      :callback-params="{key:'paymentTermHBL'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SpaceRquirement')">
                    <el-input v-model="job.cabinReq" no="52" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.OnBoardRequirements')">
                    <el-input v-model="job.loadReq" no="53" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.DocumentationRequirements')">
                    <el-input v-model="job.docReq" no="54" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CargoType')">
                    <cargo-advance-select
                      no="55"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_CargoType"
                      callback-method-type="value"
                      :default-value="job.cargoType"
                      :callback-params="{key:'cargoType'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CargoSize')">
                    <el-input v-model="job.measurements" no="56" :disabled="viewStatus" type="textarea" :rows="3" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SellingPrice')">
                    <el-input v-model="job.selling" no="57" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.BuyingPrice')">
                    <el-input v-model="job.buying" no="58" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ProtocolType')">
                    <cargo-advance-select
                      no="59"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.local_cache_SystemConstants$PROTOCOL_TYPES"
                      callback-method-type="value"
                      :default-value="String(job.protocolType)||''"
                      tag-name="chineseName"
                      :callback-params="{key:'protocolType'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.OperationRequirements')">
                    <el-input v-model="job.operationContent" no="60" :disabled="viewStatus" type="textarea" :rows="3" />
                  </el-form-item>
                </fieldset></el-card>
              <el-card class="form-card">
                <fieldset>
                  <el-form-item :label="$t('SeaExport.SalesBranchCompany')">
                    <el-input v-model="txtSalesOffice" no="61" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Sales')">
                    <div style="display: flex;justify-content: space-between">
                      <cargo-advance-select
                        no="62"
                        filterable
                        :disabled="viewStatus"
                        :select-type="selectTypeNames.basic_data_User"
                        callback-method-type="value"
                        :default-value="job.sales||''"
                        style="width: 130px"
                        :callback-params="{key:'sales'}"
                        @parentCallBack="setJobSelectValue"
                      />
                      <el-checkbox v-model="job.isProvisioned" no="63" :disabled="viewStatus">{{ $t('SeaExport.Accrued') }}</el-checkbox>
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SalesOfGoods')">
                    <cargo-advance-select
                      no="64"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_User"
                      callback-method-type="value"
                      :default-value="job.cargoSalesId==0?'':job.cargoSalesId"
                      :callback-params="{key:'cargoSalesId'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.SalesDepartment')">
                    <cargo-department-select
                      no="65"
                      :disabled="viewStatus"
                      :office-id="Number(job.salesOffice)"
                      :department-id="Number(job.salesDepartment)"

                      @change="p=>{job.salesDepartment=p.value}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.OperationCompany')">
                    <cargo-advance-select
                      no="66"
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_Office"
                      filterable
                      :callback-params="{key:'opOffice'}"
                      callback-method-type="value"
                      :default-value="job.opOffice"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Department')">
                    <cargo-department-select
                      no="67"
                      :disabled="viewStatus"
                      :office-id="Number(job.opOffice)"
                      :department-id="Number(job.opDepartment)"

                      @change="p=>{job.opDepartment=p.value}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Operation')">
                    <cargo-advance-select
                      no="68"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_User"
                      callback-method-type="value"
                      :default-value="job.op==0?'':job.op"
                      :callback-params="{key:'op'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.CustomerService')">
                    <cargo-advance-select
                      no="69"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_User"
                      callback-method-type="value"
                      :default-value="job.csr==0?'':job.csr"
                      :callback-params="{key:'csr'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Documents')">
                    <cargo-advance-select
                      no="70"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_User"
                      callback-method-type="value"
                      :default-value="job.dc==0?'':job.dc"
                      :callback-params="{key:'dc'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.AirlinePerson2')">
                    <cargo-advance-select
                      no="71"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_User"
                      callback-method-type="value"
                      :default-value="job.planner==0?'':job.planner"
                      :callback-params="{key:'planner'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.FieldOperation')">
                    <cargo-advance-select
                      no="72"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_User"
                      callback-method-type="value"
                      :default-value="job.siteOP==0?'':job.siteOP"
                      :callback-params="{key:'siteOP'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.OverseaOperation')">
                    <cargo-advance-select
                      no="73"
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_User"
                      callback-method-type="value"
                      :default-value="job.overseaOp==0?'':job.overseaOp"
                      :callback-params="{key:'overseaOp'}"
                      @parentCallBack="setJobSelectValue"
                    />
                  </el-form-item>
                  <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
                    <cargo-user-select
                      ref="userDefinedRoleId1"
                      no="userDefinedRoleId1"
                      :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                      :default-value="job.userDefinedRoleId1||''"
                      :merge-load="true"
                      :disabled="viewStatus"
                      @change="p=>{pm.userDefinedRoleId1Handler(p)}"
                    />
                  </el-form-item>
                  <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
                    <cargo-user-select
                      ref="userDefinedRoleId2"
                      no="userDefinedRoleId2"
                      :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                      :default-value="job.userDefinedRoleId2||''"
                      :merge-load="true"
                      :disabled="viewStatus"
                      @change="p=>{pm.userDefinedRoleId2Handler(p)}"
                    />
                  </el-form-item>
                  <div>
                    <special-requests-grid v-model="job.satisfiedRequests" :customer-id="job.customerId" :lob="job.lob" :job="job" :is-edit="!viewStatus" />
                    <div v-if="!viewStatus" style="display: flex;justify-content: flex-end">
                      <el-button no="74" type="primary">{{ $t('SeaExport.Add') }}</el-button>
                      <el-button no="75" type="primary">{{ $t('SeaExport.Delete') }}</el-button>
                    </div>
                  </div>
                  <el-form-item :label="$t('SeaExport.HsCode')" style="margin-top: 10px">
                    <el-input v-model="job.hsCode" no="76" :disabled="viewStatus" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.AdditionalNotes')">
                    <el-input v-model="job.remarks" no="76" :disabled="viewStatus" type="textarea" :rows="5" />
                  </el-form-item>
                </fieldset></el-card>
              <el-card class="form-card">
                <fieldset>
                  <el-form-item :label="$t('SeaExport.UserDefinedField1')">
                    <el-input v-model="job.userDefinedField1" no="77" :disabled="viewStatus" type="textarea" :rows="5" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.UserDefinedField2')">
                    <el-input v-model="job.userDefinedField2" no="78" :disabled="viewStatus" type="textarea" :rows="5" />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.UserDefinedField3')">
                    <el-input v-model="job.userDefinedField3" no="79" :disabled="viewStatus" type="textarea" :rows="5" />
                  </el-form-item>
                </fieldset></el-card>
            </div>
            <el-card class="form-card second-row-card">
              <fieldset style="width: fit-content">
                <el-form-item label="" class="custom">
                  <div style="display: flex;justify-content: flex-start" class="title-row">
                    <div style="font-size: 12px;font-weight: normal;color: #404144;margin-right: 330px;">{{ $t('SeaExport.Quantity') }}</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.Weight') }}KGS</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.Cubage') }}CBM</div>
                    <div style="font-size: 12px;font-weight: normal;color: #404144">{{ $t('SeaExport.ChargedWeight') }}M/T</div>
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Consignation')" class="custom content-row">
                  <div style="display: flex;justify-content: flex-start">
                    <el-input-number no="80" :value="job.quantityContract===0 ? undefined: job.quantityContract" :disabled="viewStatus" controls-position="right" />
                    <el-input-number no="81" :value="job.weightContract===0 ? undefined: job.weightContract" :disabled="viewStatus" controls-position="right" :precision="3" />
                    <el-input-number no="82" :value="job.cubageContract===0 ? undefined: job.cubageContract" :disabled="viewStatus" controls-position="right" :precision="3" />
                    <el-input-number no="83" :value="job.chargeWeight===0 ? undefined: job.chargeWeight" :disabled="viewStatus" controls-position="right" :precision="3" />
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Booking')" class="custom content-row">
                  <div style="display: flex;justify-content: flex-start">
                    <el-input-number no="84" :value="job.quantityBooking===0 ? undefined: job.quantityBooking" :disabled="viewStatus" controls-position="right" />
                    <el-input-number no="85" :value="job.weightBooking===0 ? undefined: job.weightBooking" :disabled="viewStatus" controls-position="right" :precision="3" />
                    <el-input-number no="86" :value="job.cubageBooking===0 ? undefined: job.cubageBooking" :disabled="viewStatus" controls-position="right" :precision="3" />
                    <el-input-number no="87" :value="job.chargeWeightBooking===0 ? undefined: job.chargeWeightBooking" :disabled="viewStatus" controls-position="right" :precision="3" />
                  </div>
                </el-form-item>
                <el-form-item :label="$t('SeaExport.Actual')" class="custom content-row">
                  <div style="display: flex;justify-content: flex-start">
                    <el-input-number no="88" :value="job.quantityActual===0 ? undefined: job.quantityActual" :disabled="viewStatus" controls-position="right" />
                    <el-input-number no="89" :value="job.weightActual===0 ? undefined: job.weightActual" :disabled="viewStatus" controls-position="right" :precision="3" />
                    <el-input-number no="90" :value="job.cubageActual===0 ? undefined: job.cubageActual" :disabled="viewStatus" controls-position="right" :precision="3" />
                    <el-input-number no="91" :value="job.cWeight===0 ? undefined: job.cWeight" :disabled="viewStatus" controls-position="right" :precision="1" />
                  </div>
                </el-form-item>
                <el-form-item v-if="job.operateType!==0" :label="$t('SeaExport.Documentation')" class="custom content-row">
                  <div style="display: flex;justify-content: flex-start">
                    <el-input-number no="92" :value="mawbDoc.quantity===0 ? undefined: mawbDoc.quantity" :disabled="viewStatus" controls-position="right" />
                    <el-input-number no="93" :value="mawbDoc.weight===0 ? undefined: mawbDoc.weight" :disabled="viewStatus" controls-position="right" :precision="3" />
                    <el-input-number no="94" :value="mawbDoc.cubage===0 ? undefined: mawbDoc.cubage" :disabled="viewStatus" controls-position="right" :precision="3" />
                    <el-input-number no="95" :value="mawbDoc.cWeight===0 ? undefined: mawbDoc.cWeight" :disabled="viewStatus" controls-position="right" :precision="1" />
                  </div>
                </el-form-item>
                <div style="display:flex;justify-content: flex-start">
                  <el-form-item
                    :label="$t('SeaExport.Package')"
                  >
                    <!-- <cargo-advance-select
                      filterable
                      :disabled="viewStatus"
                      :select-type="selectTypeNames.basic_data_Packing"
                      callback-method-type="value"
                      :default-value="job.packing"
                      tag-name="chineseName"
                      :callback-params="{key:'packing'}"
                      style="width: 210px"
                      @parentCallBack="setJobSelectValue"
                    /> -->
                    <cargo-packing-select
                      no="96"
                      :default-value="job.packing"
                      :callback-params="{}"
                      @change="p => {p.key = 'packing';setJobSelectValue(p)}"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.pbProportion')" label-width="80px" style="margin-left: 85px;" class="custom">
                    <div style="display: flex;width: 210px"><el-input-number v-model="job.pbProportion" no="97" :disabled="viewStatus" controls-position="right" style="flex:1" /><span>%</span></div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.pbProportion2')" label-width="80px" style="margin-left: 65px;">
                    <div style="display: flex;width: 210px"><el-input-number v-model="job.pbProportion2" no="98" controls-position="right" :disabled="viewStatus" style="flex:1" /><span>%</span></div>
                  </el-form-item>
                </div>
              </fieldset>
            </el-card>
            <el-card class="form-card">
              <fieldset style="width: 950px">
                <div style="display:flex;justify-content: space-between;">
                  <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')" style="margin-right: 55px;">
                    <div style="position:relative">
                      <el-input v-model="job.cargoEnglishName" no="99" :disabled="viewStatus" type="textarea" :rows="8" />
                      <char-count :value="job.cargoEnglishName" />
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.Marks')" style="margin-right: 55px;">
                    <div style="position:relative">
                      <el-input v-model="job.mark" no="100" :disabled="viewStatus" type="textarea" :rows="8" />
                      <char-count :value="job.mark" />
                    </div>
                  </el-form-item>
                  <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')" style="margin-right: 45px;">
                    <el-input v-model="job.cargoChineseName" no="101" :disabled="viewStatus" type="textarea" :rows="8" />
                  </el-form-item>
                </div>
              </fieldset>

            </el-card>
          </div>
        </div>
      </el-form>
      <div class="form-card-wrapper custom-delivery-info" style="width: 100%">
        <el-card class="form-card" style="flex: 1">
          <el-form label-position="left" label-width="90px">
            <fieldset style="min-height: 300px;">
              <legend>{{ $t('SeaExport.CustomerDeliveryInfo') }}</legend>
              <el-row :gutter="6">
                <el-col :span="6">
                  <!-- todo ShipperAutoComplete-->
                  <el-form-item :label="$t('SeaExport.Shipper')" class="custom">
                    <div style="display: flex;">
                      <cargo-advance-select
                        no="102"
                        filterable
                        :disabled="viewStatus"
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{shipper:true}"
                        callback-method-type="value"
                        :default-value="job.shipperId ||''"
                        tag-name="englishName"
                        style="flex:1;margin-right: 5px"
                        :callback-params="{key:'shipperId'}"
                        @parentCallBack="setJobSelectValue"
                      />
                      <el-button slot="append" no="103" type="primary" :disabled="viewStatus">{{ $t('SeaExport.CodeSearching') }}</el-button>
                    </div>
                    <!-- <el-input v-model="job.shipperId" :disabled="viewStatus">
                          <el-button slot="append" type="primary">{{ $t('SeaExport.CodeSearching') }}</el-button>
                        </el-input>-->
                  </el-form-item>
                  <el-input v-model="job.shipperLine1" no="104" :disabled="viewStatus" />
                  <el-input v-model="job.shipperLine2" no="105" :disabled="viewStatus" />
                  <el-input v-model="job.shipperLine3" no="106" :disabled="viewStatus" />
                  <el-input v-model="job.shipperLine4" no="107" :disabled="viewStatus" />
                  <el-input v-model="job.shipperLine5" no="108" :disabled="viewStatus" />
                  <el-input v-model="job.shipperLine6" no="109" :disabled="viewStatus" />
                  <char-count inline :form="job" prefix="shipper" :line-count="6" style="float:right" />
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('SeaExport.Consignee')" class="custom">
                    <div style="display: flex;">
                      <cargo-advance-select
                        no="110"
                        filterable
                        :disabled="viewStatus"
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{consignee:true}"
                        callback-method-type="value"
                        :default-value="job.consigneeId ||''"
                        tag-name="englishName"
                        style="flex:1;margin-right: 5px"

                        :callback-params="{key:'consigneeId'}"
                        @parentCallBack="setJobSelectValue"
                      />
                      <el-button slot="append" no="111" type="primary" :disabled="viewStatus">{{ $t('SeaExport.CodeSearching') }}</el-button>
                    </div>
                  </el-form-item>
                  <el-input v-model="job.consigneeLine1" no="112" :disabled="viewStatus" />
                  <el-input v-model="job.consigneeLine2" no="113" :disabled="viewStatus" />
                  <el-input v-model="job.consigneeLine3" no="114" :disabled="viewStatus" />
                  <el-input v-model="job.consigneeLine4" no="115" :disabled="viewStatus" />
                  <el-input v-model="job.consigneeLine5" no="116" :disabled="viewStatus" />
                  <el-input v-model="job.consigneeLine6" no="117" :disabled="viewStatus" />
                  <char-count inline :form="job" prefix="consignee" :line-count="6" style="float:right" />
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('SeaExport.NotifyParty')" class="custom">
                    <div style="display: flex">
                      <cargo-advance-select
                        no="118"
                        filterable
                        :disabled="viewStatus"
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{notify:true}"
                        callback-method-type="value"
                        :default-value="job.notifyId ||''"
                        tag-name="englishName"
                        style="flex:1;margin-right: 5px"

                        :callback-params="{key:'notifyId'}"
                        @parentCallBack="setJobSelectValue"
                      />
                      <el-button slot="append" type="primary" :disabled="viewStatus">{{ $t('SeaExport.CodeSearching') }}</el-button>
                    </div>
                  </el-form-item>
                  <el-input v-model="job.notifyLine1" no="119" :disabled="viewStatus" />
                  <el-input v-model="job.notifyLine2" no="120" :disabled="viewStatus" />
                  <el-input v-model="job.notifyLine3" no="121" :disabled="viewStatus" />
                  <el-input v-model="job.notifyLine4" no="122" :disabled="viewStatus" />
                  <el-input v-model="job.notifyLine5" no="123" :disabled="viewStatus" />
                  <el-input v-model="job.notifyLine6" no="124" :disabled="viewStatus" />
                  <char-count inline :form="job" prefix="notify" :line-count="6" style="float:right" />
                </el-col>
                <el-col :span="6">
                  <span style="display:inline-block;line-height:32px;padding-bottom: 7px;">{{ $t('SeaExport.SecondNotifyParty') }}</span>
                  <el-input v-model="job.alsoNotify" no="125" :disabled="viewStatus" type="textarea" :rows="11" />
                </el-col>
              </el-row>
            </fieldset>
          </el-form>
        </el-card>
      </div>
    </div>
    <cargo-contacts-info-dialog
      v-if="showContactsInfoDialog"
      :visible.sync="showContactsInfoDialog"
      :customer-id="job.customerId"
      :customer-contact="job.customerContact"
    />
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'

import cargoContactsInfoDialog from '@/components/Cargo/Job/cargoContactsInfoDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import SpecialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import selectData from '@/utils/selectData'
import { cacheName, cache } from '@/utils/cacheManager'

import { BasicTabHP } from './basicTabHP'
import NumberInput from '@/components/Cargo/Common/numberInput'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'

export default {
  name: 'BasicTab',
  components: { NumberInput, cargoPackingSelect, cargoDepartmentSelect, SpecialRequestsGrid, cargoAdvanceSelect, cargoContactsInfoDialog },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      isZh: this.$store.getters.language === 'zh',
      pm: new BasicTabHP(this),
      selectTypeNames: TYPE_NAMES,
      showContactsInfoDialog: false,
      job: new AirExportJob().fillDefaultValue().getData(),
      mawbDoc: { // 主单
        quantity: 0.0,
        weight: 0.0,
        cubage: 0.0,
        cWeight: 0.0
      },
      txtSalesOffice: '', // 销售所在分公司
      contractStatuses: selectData.contractStatuses,
      contractStatusLabel: '',
      customerTip: '',
      customerLevel: {
        level: '',
        customerName: ''
      },
      advancePaymentLabel: '', // 预付款(中邮)
      optStatusDefs: {
        edit: 'edit', // edit
        view: 'view' // 查看
      },
      currentOptStatus: 'view',
      officeList: [],
      config: {},
      configValue: {
        creditOpen: false // 是否开启信控
      },
      creditTip: { // 信控超期提醒
        showWarningImageA: false,
        warningImageATip: '',
        showWarningImageB: false,
        warningImageBTip: '',
        showWarningImageC: false,
        warningImageCTip: ''
      },
      isAddUserDefinedRoles: false // 是否显示自定义岗位
    }
  },
  computed: {
    viewStatus() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    editStatus() {
      return this.optStatusDefs.edit === this.currentOptStatus
    }
  },

  watch: {
  },
  async created() {
    await this.prepareData()
  },
  beforeMount() {
  },
  methods: {
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    },
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      // todo created 未加载完成导致config 未获取到
      await this.prepareData()

      if (row.uuid) {
        const job = new AirExportJob(row)
        this.job = job
        this.pm.loadCustomerLevel()
        this.pm.loadCompanyOffice()
        this.pm.updateView()

        if (this.job.cargoDoc && this.job.cargoDoc.length > 0) {
          const mawbDoc = this.job.cargoDoc.find(item => item.docType === 'MAWB')
          if (mawbDoc) {
            this.mawbDoc = mawbDoc
            const airCargoDoc = this.job.airCargoDoc.find(item => item.uuid === this.mawbDoc.uuid)
            if (airCargoDoc) {
              this.mawbDoc.cWeight = airCargoDoc.cWeight
            }
          }
        }
      }
    },
    /**
     * 准备好数据
     */
    async prepareData() {
      this.loading = true
      await cache.load(cacheName.OFFICE_LIST, cacheName.CONFIG)
      this.officeList = cache.officeList
      this.config = cache.config
      this.isAddUserDefinedRoles = Number(this.config.get('IsAddUserDefinedRoles')) === 1
      this.configValue.creditOpen = Number(this.config.get('creditOpen')) === 1
      this.loading = false
    }
  }
}
</script>

<style lang="scss">
  .ae-basic-from {
    .second-row-card {
      .title-row {
        div {
          margin-right: 305px;
        }
      }
      .content-row {
        .el-input-number {
          margin-right: 145px;
          width: 210px!important;
        }
      }
    }

    .custom-delivery-info {
      .el-col {
        & > .el-input {
          margin-bottom: 8.5px;
        }
      }
    }
  }
</style>
